import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './datePickerTheme.css';

/**
 * Visual shell for the existing react-datepicker fields.
 * Selection, formatting, min/max dates, and dropdown behaviour are unchanged.
 * Drop this file beside the onboarding step components, with datePickerTheme.css.
 */
const CalendarGlyph = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect
      x="3.25"
      y="4.75"
      width="17.5"
      height="15.5"
      rx="3"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path d="M3.25 9.5h17.5" stroke="currentColor" strokeWidth="1.7" />
    <path
      d="M8 3.25v3.4M16 3.25v3.4"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <path
      d="M8.2 13.2h.01M12 13.2h.01M15.8 13.2h.01M8.2 16.7h.01M12 16.7h.01"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
  </svg>
);

const joinClass = (...parts) => parts.filter(Boolean).join(' ');

const ThemedDatePicker = ({
  className = '',
  wrapperClassName = '',
  calendarClassName = '',
  popperClassName = '',
  invalid = false,
  disabled = false,
  inline = false,
  portalId = 'theme-datepicker-portal',
  showPopperArrow = false,
  ...props
}) => {
  const calendarClass = joinClass('theme-datepicker', calendarClassName);
  const popperClass = joinClass('theme-datepicker-popper', popperClassName);

  if (inline) {
    return (
      <DatePicker
        {...props}
        inline
        disabled={disabled}
        calendarClassName={calendarClass}
      />
    );
  }

  return (
    <div
      className={joinClass(
        'theme-date-field',
        invalid && 'is-invalid',
        disabled && 'is-disabled',
        wrapperClassName,
      )}
    >
      <DatePicker
        {...props}
        disabled={disabled}
        portalId={portalId}
        showPopperArrow={showPopperArrow}
        calendarClassName={calendarClass}
        popperClassName={popperClass}
        wrapperClassName="w-full"
        className={joinClass('theme-date-input', className)}
        aria-invalid={invalid || undefined}
      />
      <span className="theme-date-field__icon" aria-hidden="true">
        <CalendarGlyph />
      </span>
    </div>
  );
};

export default ThemedDatePicker;
